import { makeAutoObservable } from 'mobx';

export default class PreviewStore {
    isInitialized: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isInitialized = false;
    }

    setIsInitialized = (value: boolean): void => {
        this.isInitialized = value;
    };
}
